import { icons } from "lucide-react";
import { cn } from "@/lib/utils";
import { Badge as BadgeT } from "@/payload-types";
import { resolveRelationshipId } from "@/lib/utils/theme-configuration-class";
import "./style.scss";

export type BadgeVariant = BadgeT | BadgeT["id"] | "default" | null;

interface BadgeProps {
	children?: React.ReactNode;
	variant?: BadgeVariant;
	className?: string;
	hover?: boolean;
	iconBefore?: string | null;
	iconAfter?: string | null;
}

export const Badge: React.FC<BadgeProps> = ({ children, variant = "default", className, hover = false, iconBefore, iconAfter }) => {
	const variantId = resolveRelationshipId(variant);
	const IconBefore = iconBefore ? icons[iconBefore as keyof typeof icons] : undefined;
	const IconAfter = iconAfter ? icons[iconAfter as keyof typeof icons] : undefined;
	const hasContent = children != null && children !== "";

	return (
		<div className={cn("flex transition border-box select-none w-max", "ms-badge-" + variantId, hover && "ms-badge-with-hover", className)}>
			{IconBefore || IconAfter ? (
				<span className="inline-flex items-center gap-1.5">
					{IconBefore && <IconBefore className="size-4 ms-badge-icon" />}
					{hasContent && <span>{children}</span>}
					{IconAfter && <IconAfter className="size-4 ms-badge-icon" />}
				</span>
			) : (
				children
			)}
		</div>
	);
};
